export default __webpack_public_path__ + "static/media/qlds.82c12579.png";